import _ from 'lodash'

export default function getValidSpecialPackages(specialPackageRates, availRatePlans, availRoomRates, currentRoomType) {
	// Init validation of special packages compared to roomRates
	let hasValidSpecialPackages = false

	// Compare config specialPackageRates to availability data for valid rates
	if (!_.isEmpty(specialPackageRates)) {
		specialPackageRates.forEach(rateKey => {
			availRoomRates.forEach(rates => {
				if (
					rates.roomTypeCode === currentRoomType &&
					rates.ratePlanCode === rateKey
				) {
					const applicablePlanData = availRatePlans.filter(function(plan){
						return plan.ratePlanCode === rateKey
					})

					if (applicablePlanData[0]) {
						hasValidSpecialPackages = true
					}
				}
			})
		})
	}

	return hasValidSpecialPackages
}


// WEBPACK FOOTER //
// ./src/utilities/content/hasValidSpecialPackages.js